import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './context/ProtectedRoute';
import PublicRoute from './context/PublicRoute';

// Import only essential components
import Home from './pages/Home';
import OurProfile from './pages/About/OurProfile';
import OurTeam from './pages/About/OurTeam';
import ContactUs from './pages/About/ContactUs';
import BlogsPage from './pages/Blogs/BlogsPage';
import BlogDetailPage from './pages/Blogs/BlogDetailPage';
import OurStoryPage from './pages/OurStory/OurStory';
import WhatWeOfferPage from './pages/WhatweOffer/whatweofferpage';
import SiriDhariniFarmPage from './pages/OurFarm/SiriDhariniFarmPage';

// Import admin components
import AdminLogin from './pages/Admin/AdminLogin';
import AdminPanel from './pages/Admin/AdminPanel';
import AdminSignupPage from './pages/Admin/AdminSignUpPage';
import SiridhariniBlogAdminUpload from './pages/Admin/SiridhariniBlogAdminUpload';
import SiridhariniBlogManagement from './pages/Admin/SiridhariniBlogManagement';

import './App.css';

// Wrapper component for routes
const AnimatedRoutes = () => {
  return (
    <Routes>
          {/* Essential Routes Only */}
          <Route path="/" element={<Home />} />
          <Route path="/ourstory" element={<OurStoryPage />} />
          <Route path="/about/profile" element={<OurProfile />} />
          <Route path="/about/team" element={<OurTeam />} />
          <Route path="/about/contact" element={<ContactUs />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/blogs/:id" element={<BlogDetailPage />} />
          <Route path="/ourfarm" element={<SiriDhariniFarmPage />} />
          <Route path="/whatweoffer" element={<WhatWeOfferPage />} />
          
          {/* Admin Login Route - Public but redirects if already logged in */}
          <Route 
            path="/admin" 
            element={
              <PublicRoute>
                <AdminLogin />
              </PublicRoute>
            } 
          />
          
          {/* Protected Admin Routes - Require authentication and admin role */}
          <Route 
            path="/adminportal" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminPanel />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/adminportal/signup" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminSignupPage />
              </ProtectedRoute>
            } 
          />
          
          {/* Siridharini Blog Admin Routes - Protected */}
          <Route 
            path="/adminportal/siridharini-blog-upload" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <SiridhariniBlogAdminUpload />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/adminportal/siridharini-blog-upload/edit/:id" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <SiridhariniBlogAdminUpload />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/adminportal/siridharini-blogs" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <SiridhariniBlogManagement />
              </ProtectedRoute>
            }
          />
          
          {/* Development route for testing - Remove in production */}
          <Route 
            path="/admin/siridharini-blog-upload" 
            element={<SiridhariniBlogAdminUpload />}
          />
        </Routes>
  );
};

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App">
            <AnimatedRoutes />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;